import { EmailTemplateEventEnum } from "helpers/constants";
import { UseFormSetValue } from "react-hook-form";
import { BasicActivity } from "types/activity.type";
import {
  ActivityEmailTemplate,
  EmailTemplate,
  NewActivityEmailTemplate,
} from "types/emailTemplate.type";
import { HEADER_OPTIONS } from "./EmailTemplateAssignmentTable.constants";
import { EmailTemplateAssignmentForm } from "./EmailTemplateAssignmentTable.type";

export const findActivityEmailTemplate = (
  activitiesEmails: NewActivityEmailTemplate[],
  activityId: number,
  triggerEvent: EmailTemplateEventEnum,
): NewActivityEmailTemplate => {
  return (
    activitiesEmails.find(
      (activityEmail) =>
        activityEmail.activityId === activityId &&
        activityEmail.triggerEvent === triggerEvent,
    ) ?? {
      activityId,
      triggerEvent,
      templateId: null,
    }
  );
};

export const filterTemplatesByEvent = (
  templates: EmailTemplate[],
  triggerEvent: EmailTemplateEventEnum,
) => {
  return templates.filter((template) => template.triggerEvent === triggerEvent);
};

export const generateFilteredTemplates = (templates: EmailTemplate[]) => {
  return HEADER_OPTIONS.reduce(
    (acc, option) => {
      acc[option.type] = filterTemplatesByEvent(templates, option.type);
      return acc;
    },
    {} as Record<EmailTemplateEventEnum, EmailTemplate[]>,
  );
};

export const generateFiledName = (
  activityId: number,
  triggerEvent: EmailTemplateEventEnum,
): `activityTemplates.${string}` =>
  `activityTemplates.${activityId}-${triggerEvent}`;

export const setActivityEmailTemplatesFormValue = (
  activities: BasicActivity[],
  activityEmailTemplates: ActivityEmailTemplate[],
  setValue: UseFormSetValue<EmailTemplateAssignmentForm>,
) => {
  activities.forEach((activity) => {
    HEADER_OPTIONS.forEach(({ type: triggerEvent }) => {
      const template = findActivityEmailTemplate(
        activityEmailTemplates,
        activity.id,
        triggerEvent,
      );
      setValue(generateFiledName(activity.id, triggerEvent), template);
    });
  });
};

export function getEmailTemplatesFromFormData(
  formData: EmailTemplateAssignmentForm,
): NewActivityEmailTemplate[] {
  return Object.values(formData.activityTemplates).filter(
    (template): template is NewActivityEmailTemplate => template !== null,
  );
}
